<template>
  <page-listado>
    <page-header title="Cliente">
      <b-button variant="primary" size="sm" to="/clientes/crear">
        <v-icon name="plus" width="16" />
        Crear cliente
      </b-button>
      <busqueda-rapida />
    </page-header>
    <tabla-clientes :clientes="resultado.clientes" />
    <paginacion :page-count="resultado.numeroPaginas" :page="resultado.pagina" />
  </page-listado>
</template>

<script>
import * as clienteApi from "@/services/clientes.js";
import TablaClientes from "./TablaClientes.vue";
export default {
  components: { TablaClientes },
  data() {
    return {
      resultado: {
        clientes: [],
        numeroPaginas: 0,
        pagina: 1,
      },
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    listar() {
      return clienteApi.listar(this.$route.query).then((resultado) => {
        this.resultado = resultado;
      });
    },
  },
};
</script>
